// @core/api/endpoints/search/delete_document.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/search';

/**
 * Delete indexed document
 * Removes a document from the search index by its entity URN.
 */
export async function DeleteDocument(
  entity_urn: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/search/documents/:entity_urn`;
  requestPath = requestPath.replace(':entity_urn', encodeURIComponent(entity_urn));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
